import { AxiosError, AxiosRequestConfig } from 'axios';
import axiosInstance from '../config/axios';
import * as Sentry from "@sentry/react";

export class HttpService {

    public static async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
        try {
            const response = await axiosInstance.get<T>(url, config);
            return response.data;
        } catch (error) {
            Sentry.captureException(error);
            if (error instanceof AxiosError && error.response?.data?.message) {
                throw new Error(error.response.data.message);
            }
            throw error;
        }
    }

    public static async post<T>(url: string, data: any, config?: AxiosRequestConfig): Promise<T> {
        try {
            const response = await axiosInstance.post<T>(url, data, config);
            return response.data;
        } catch (error: any) {           
            Sentry.captureException(error);
            if (error instanceof AxiosError && error.response?.data?.message) {
                throw new Error(error.response.data.message);
            }
            throw error;
        }
    }

    public static async put<T>(url: string, data: any, config?: AxiosRequestConfig): Promise<T> {
        try {
            const response = await axiosInstance.put<T>(url, data, config);
            return response.data;
        } catch (error) {
            Sentry.captureException(error);
            if (error instanceof AxiosError && error.response?.data?.message) {
                throw new Error(error.response.data.message);
            }
            throw error;
        }
    }

    public static async patch<T>(url: string, data: any, config?: AxiosRequestConfig): Promise<T> {
        try {
            const response = await axiosInstance.patch<T>(url, data, config);
            return response.data;
        } catch (error) {
            Sentry.captureException(error);
            if (error instanceof AxiosError && error.response?.data?.message) {
                throw new Error(error.response.data.message);
            }
            throw error;
        }
    }

    public static async delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
        try {
            const response = await axiosInstance.delete<T>(url, config);
            return response.data;
        } catch (error) {
            Sentry.captureException(error);
            if (error instanceof AxiosError && error.response?.data?.message) {
                throw new Error(error.response.data.message);
            }
            throw error;
        }
    }
}

export default HttpService;


